<template>
  <div class="min-vh-100">
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">SETTING BRAND</h1>
      <button class="create-button" @click="onOpenModal">
        <font-awesome-icon icon="plus-square" />
        <span class="ml-2"> CREATE</span>
      </button>
    </div>
    <div class="mt-3 main-theme bg-white-border p-3">
      <b-table
        responsive
        striped
        hover
        class="table-list"
        :items="items"
        :fields="fields"
        :busy="isBusy"
        show-empty
        empty-text="ไม่พบข้อมูล"
      >
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(platformId)="data">
          <img
            v-if="data.item.platformId == 1"
            src="@/assets/images/icons/line.png"
            class="mx-auto d-block"
            width="40"
          />
          <img
            v-else-if="data.item.platformId == 4"
            src="@/assets/images/icons/facebook.png"
            class="mx-auto d-block"
            width="40"
          />
          <img
            v-else-if="data.item.platformId == 5"
            src="@/assets/images/icons/instagram.png"
            class="mx-auto d-block"
            width="40"
          />
        </template>
        <template v-slot:cell(isActive)="data">
          <span v-if="data.item.isActive" class="text-success">Active</span>
          <span v-else class="text-danger">Inactive</span>
        </template>
        <template v-slot:cell(id)="data">
          <div class="d-flex justify-content-around">
            <b-link
              class="text-link"
              @click="onEdit(data.item)"
              :disabled="![1].includes(data.item.platformId)"
              >Edit</b-link
            >
            <b-link class="text-link" @click="onDeleteModal(data.item)"
              >Delete</b-link
            >
          </div>
        </template>
      </b-table>
      <b-row class="no-gutters px-3 px-sm-0">
        <b-col
          class="form-inline justify-content-center justify-content-sm-between"
        >
          <div v-if="rows > 0" class="my-auto">{{ rows }} entires</div>
        </b-col>
      </b-row>
    </div>
    <ModalAlert
      ref="modalAlert"
      :text="modalMessage"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalAlertConfirm
      msg="ยืนยันการลบ ?"
      :text="modalMessage"
      btnConfirm="ลบ"
      colorBtnConfirm="danger"
      btnCancel="ยกเลิก"
      ref="ModalAlertConfirm"
      @confirm="onDeleteData"
    />
    <ModalCreatePlatform
      :platformIdList="platformIdList"
      @handleLINE="handleLINE"
      ref="modalCreatePlatform"
      @handleSuccess="handleSuccess"
      @handleFail="handleFail"
    />
    <ModalConnectLineChannel
      ref="modalConnectLineChannel"
      @handleSuccess="handleSuccess"
      @handleFail="handleFail"
    />
  </div>
</template>

<script>
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import ModalCreatePlatform from "./components/ModalCreatePlatform.vue";
import ModalConnectLineChannel from "./components/ModalConnectLineChannel.vue";
export default {
  name: "SettingTime",
  components: {
    ModalAlert,
    ModalAlertConfirm,
    ModalAlertError,
    ModalCreatePlatform,
    ModalConnectLineChannel,
  },
  data: function () {
    return {
      modalMessage: "",
      bodyDelete: {
        platformId: 0,
        channelId: 0,
      },
      isBusy: false,
      startPage: 1,
      endPage: 10,
      rows: 0,
      platformIdList: [],
      fields: [
        {
          key: "platformName",
          label: "Channel Name",
          class: "w-100px",
        },
        {
          key: "pageName",
          label: "Page",
          class: "w-100px",
          tdClass: "text-left",
        },
        {
          key: "platformId",
          label: "Platform",
          class: "w-100px",
        },
        {
          key: "isActive",
          label: "Status",
          class: "w-100px",
        },
        {
          key: "id",
          label: "",
          class: "w-100px",
        },
      ],
      items: [],
    };
  },

  created: async function () {
    await this.getList();
  },
  methods: {
    getList: async function () {
      this.platformIdList = [];
      this.isBusy = true;
      await this.axios
        .get(`${this.$baseUrl}/system/platformlist`)
        .then((data) => {
          if (data.result == 1) {
            this.items = data.detail;
            this.rows = data.detail.length;
            this.items.forEach((ele) => {
              this.platformIdList.push(ele.platformId);
            });
          }
        });
      this.isBusy = false;
    },
    onOpenModal() {
      this.$refs.modalCreatePlatform.showModal = true;
    },
    handleLINE() {
      this.$refs.modalConnectLineChannel.onShowModal();
    },
    onEdit(item) {
      this.$refs.modalConnectLineChannel.onShowModal(item);
    },
    onDeleteModal(data) {
      this.bodyDelete.platformId = data.platformId;
      this.bodyDelete.channelId = data.channelConfigId;
      this.modalMessage = `คุณต้องการลบ ${data.pageName} ใช่หรือไม่?`;
      this.$refs.ModalAlertConfirm.show();
    },
    async onDeleteData() {
      this.$refs.ModalAlertConfirm.hide();
      await this.axios
        .delete(
          `${this.$baseUrl}/system/lineconfig/${this.bodyDelete.platformId}/${this.bodyDelete.channelId}`
        )
        .then((data) => {
          if (data.result == 1) {
            this.handleSuccess(data.message);
          } else {
            this.handleFail(data.message);
          }
        })
        .catch((err) => {
          this.handleFail(err.message);
        });
    },
    async hadleModalAlertClose() {
      this.$refs.modalAlert.hide();
    },
    async handleSuccess(msg = false) {
      this.modalMessage = msg || "Success";
      await this.getList();
      this.$refs.modalCreatePlatform.showModal = false;
      this.$refs.modalAlert.show();
    },
    async handleFail(msg = false) {
      this.modalMessage = msg || "Fail";
      this.$refs.modalAlertError.show();
    },
  },
};
</script>

<style lang="scss" scoped>
.create-button {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  font-size: 14px;
  padding: 0.375rem 0.75rem;
  background-color: #5b57a5;
  color: #ffffff !important;
  border-radius: 4px;
  border: none;
}

::v-deep .text-link {
  text-decoration: underline;
  color: #0062ff;
}

::v-deep .text-link.disabled {
  opacity: 0.6;
  cursor: default !important;
}
</style>
